var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 27,
    viewBox: "0 0 38 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3428 9.96875H0.657913C0.289482 9.96875 0 10.2686 0 10.6503V16.3757C0 16.7574 0.289482 17.0573 0.657913 17.0573H24.3428C24.7112 17.0573 25.0007 16.7574 25.0007 16.3757V10.6503C25.0007 10.2686 24.7112 9.96875 24.3428 9.96875ZM5.05277 12.9405L3.36852 14.7944C3.28957 14.9035 3.15798 14.958 3.00008 14.958C2.8685 14.958 2.73692 14.9035 2.63165 14.7944L1.76321 13.8129C1.57899 13.5948 1.57899 13.2676 1.78952 13.0768C2.00006 12.886 2.31585 12.886 2.50007 13.1041L3.0264 13.6766L4.34223 12.2316C4.52644 12.0135 4.84224 12.0135 5.05277 12.2044C5.23699 12.3952 5.26331 12.7224 5.05277 12.9405ZM23.6849 15.6941H6.8423V11.3319H23.7112V15.6941H23.6849Z",
    fill: "#2EC5CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.657913 8.08853H17.9742C18.3426 8.08853 18.6321 7.78863 18.6321 7.40694V1.68159C18.6321 1.2999 18.3426 1 17.9742 1H0.657913C0.289482 1 0 1.2999 0 1.68159V7.37967C0 7.76136 0.289482 8.08853 0.657913 8.08853ZM6.81598 2.36318H17.3163V6.72535H6.81598V2.36318Z",
    fill: "#8C30F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9741 18.9375H0.657913C0.289482 18.9375 0 19.2374 0 19.6191V25.3172C0 25.6989 0.289482 25.9988 0.657913 25.9988H13.9741C14.3425 25.9988 14.632 25.6989 14.632 25.3172V19.6191C14.632 19.2647 14.3425 18.9375 13.9741 18.9375ZM13.3162 24.6628H6.81598V20.3007H13.3162V24.6628Z",
    fill: "#D6B1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIcon);
export default __webpack_public_path__ + "static/media/task-icon.78c0e6c739ad7dd3619dda784afe6460.svg";
export { ForwardRef as ReactComponent };